export const FILTERS_TAB_KEY = ["3"];
export const EVALUATED_TEST_STATUS_COLORS: any = {
  NEW: "#1890ff",
  "Result Declared": "geekblue",
  "Evaluation Pending": "#faad14",
  "Evaluation Completed": "green",
  Challenged: "red",
  "Evaluation Overdue": "#ff4d4f",
};
